"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgImage = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var getFullPath = function (relativePath) { return window.globalSettings.imgPath + "/" + relativePath; };
exports.SvgImage = function (props) { return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.1", className: props.className, height: props.height, width: props.width },
    react_1.default.createElement("use", { xlinkHref: getFullPath(props.image) }))); };
